$.fn.getLvWrapper = function () {
    /// <summary>Gets the parent list view wrapper</summary>
    /// <returns type="JQuery">Returns JQuery element</returns>

    return this.closest('.cLvWrap');
}
$.fn.getLv = function () {
    /// <summary>Gets the list view from the wrapper or from an element inside the list wrapper</summary>
    /// <returns type="ListView">Kendo list view</returns>

    var me = this;
    if (me.hasClass('k-listview')) return me.getKendoListView();
    else if (!me.hasClass('cLvWrap')) me = me.getLvWrapper();
    if (!me.length) return null;
    var lv = me.data('listView');
    if (!lv || !lv.length) return null;
    return lv.data('kendoListView');
}
$.fn.getLvFromTb = function (e) {
    /// <summary>Gets the list view for a toolbar button (toolbar within list view)</summary>
    /// <returns type="ListView">Kendo list view</returns>

    return $(this).getLv();
}
$.fn.refreshListDS = function (args) {
    /// <summary>Refreshes a list view data source, this method will work when called on the list view wrapper or any child elements</summary>
    /// <returns type="JQuery">Kendo list view</returns>

    this.each(function () {

        var el = $(this);
        var klv = el.getLv();
        if (!klv) return;

        // refresh data source
        klv.dataSource.read();

        // clear selections
        el.clearSelectedItemUids();

        // if no args just return
        if (!args) return;

        // set page to 1 if resetPage = true
        if (klv.dataSource.page() != 1 && args.resetPage === true) {

            klv.dataSource.page(1);
        }
    });
    return this;
}
$.fn.getListItemCount = function () {
    /// <summary>Gets the numbers of items for the matched list(s)</summary>
    /// <returns type="Integer">The number of items</returns>

    var count = 0;
    this.each(function () {

        var klv = $(this).getLv();
        count += klv.dataSource._data.length;
    });
    return count;
}
$.fn.getListSelectedVals = function (e) {
    /// <summary>Gets an array of selected values for a list, the value which is extracted is defined in the options object, the field will default to 'Id' if not specified</summary>
    /// <param name="e" type="Object">The options object</param>
    /// <returns type="Array">Array of selected values</returns>

    var selectedVals = [];

    this.each(function (i, el) {

        var lv = $(el).getLv();
        if (!lv) return null;

        var res = lv.getSelectedVal(e && e.field ? e.field : 'ID');

        if(res) {

            if (isArray(res)) {

                cafm.util.addAll(selectedVals, res);
            }
            else {

                selectedVals.push(res);
            }
        }
    });

    return selectedVals.length ? selectedVals : null;
}
$.fn.getListVals = function (e) {
    /// <summary>Gets an array of values for a list, the value which is extracted is defined in the options object, the field will default to 'Id' if not specified</summary>
    /// <param name="e" type="Object">The options object</param>
    /// <returns type="Array">Array of values</returns>

    var lv = $(this).getLv();
    var vals = [];
    var field = e && e.field ? e.field : 'ID';
    $.each(lv.dataSource.data(), function (i, dataItem) {       
        vals.push(dataItem.get(field));
    });
    return vals;
}
$.fn.getListSelectedParentChildArray = function (e) {
    /// <summary>Gets an array of selected parent child objects for a list, the value which is extracted is defined in the options object, the field will default to 'Id' if not specified, parentId must be defined in the options object</summary>
    /// <param name="e" type="Object">The options object</param>
    /// <returns type="Array">Array of selected parent child objects</returns>

    var ids = $(this).getListSelectedVals(e);
    if (!ids)
        return null;

    var dtos = [];

    if (isObj(ids)) {
        ids.forEach(function (id) {
            dtos.push({
                ParentID: { ID: e.parentId },
                ChildID: { ID: id }
            });
        });
    }
    else
        dtos.push({
            ParentID: { ID: e.parentId },
            ChildID: { ID: ids }
        });

    return dtos;
}
$.fn.getListSelectedDataItems = function () {
    /// <summary>Gets an array of selected data items for the matches list element(s)</summary>
    /// <returns type="Array">Array of selected data items</returns>

    var selected = [];

    this.each(function (i, el) {

        var lv = $(el).getLv();
        if (!lv) return null;

        var res = lv.getSelected();

        if (res) {

            if (isArray(res)) {

                cafm.util.addAll(selected, res);
            }
            else {

                selected.push(res);
            }
        }
    });

    return selected;
}
$.fn.listViewContains = function (func) {
    /// <summary>Determines if a list view contains a data item using the function passed</summary>
    /// <param name="func" type="Function">The equality determining function, which is passed each data item</param>
    /// <returns type="Boolean">True if the function matches an item in the list views datasource</returns>

    var match = cafm.util.find($(this).getLv().dataSource.data(), function (item) {
        return func(item);
    });
    return match;
}
$.fn.getListViewDataItem = function (id, f) {
    /// <summary>Matches and returns a list view data item</summary>
    /// <param name="id" type="String">The list item id to match</param>
    /// <param name="f" type="String">The field name to match</param>
    /// <returns type="Object">The list view data item</returns>

    if (!f) f = 'ID';
    var match = cafm.util.find($(this).getLv().dataSource.data(), function (item) {
        return cafm.util.getReference(f, item) == id;
    });
    return match;
}
$.fn.getSelectedItemUids = function () {
    /// <summary>Gets the selected UIDs for the list view(s)</summary>
    /// <returns type="Array">An array of selected UIDS for the list</returns>

    var selectedItemUids = [];

    this.each(function (i, el) {

        var uids = $(el).data('selectedItemUids');

        if (uids && uids.length) {

            uids.forEach(function(uid){
                
                selectedItemUids.push(uid);
            });
        }
    });

    return selectedItemUids;
}
$.fn.setSelectedItemUids = function (uids) {
    /// <summary>Sets the selected UIDs for the list view, this method just stores the UIDs it won't select the list items at the moment</summary>

    this.data('selectedItemUids', uids);
}
$.fn.clearSelectedItemUids = function () {
    /// <summary>Clears the selected UIDs for the list view, this method just clears the UIDs stored it won't deselect the list items at the moment</summary>

    this.removeData('selectedItemUids');
}
$.fn.getListItemParent = function () {
    /// <summary>Get the list item parent element of the given element</summary>
    /// <returns type="$">The list item element the element is contained in</returns>
        
    return this.closest('.cLvIt');
}
$.fn.listItemLinkClick = function (clickHandler) {
    /// <summary>Standard function to setup list item link clicks for the given list element</summary>
    /// <param name="clickHandler" type="Function">The handler function</param>
        
    this.off('click.cafm').on('click.cafm', '.cLink', function (e) {

        var item = $(e.currentTarget).getListItemParent(),
            dataItem = item.getListViewDataItem(item.data('id'), 'ID');
        clickHandler(dataItem);
    })
}
$.fn.disableListSelection = function () {
    /// <summary>Disables list selection for the matched element(s)</summary>
    /// <returns type="$">The matched element(s)</returns>

    this.each(function (i, el) {

        $(el).getLv().element.removeClass('k-selectable touch-selectable');
    });
    return this;
}
$.fn.disableListItemEditing = function () {
    /// <summary>Disables list item editing for the matched element(s)</summary>
    /// <returns type="$">The matched element(s)</returns>

    this.each(function (i, el) {

        $(el).find('[data-key="Edit"]').remove();
    });
    return this;
}
$.fn.disableListItemRemoving = function () {
    /// <summary>Disables list item removing for the matched element(s)</summary>
    /// <returns type="$">The matched element(s)</returns>

    this.each(function (i, el) {

        $(el).find('[data-key="Remove"]').remove();
    });
    return this.disableListSelection();
}

/// <summary name='cafm.lv'>Container object for CAFM ListView code</summary>
cafm.lv = {
    setup: function (o, e) {
        /// <summary>Sets up the list view, setting events, sorting options etc</summary>
        /// <param name="o" type="Object">The list view options</param>
        /// <param name="e" type="Object">The list view data bound event args</param>

        var lv = e.sender.element;
        var w = lv.getLvWrapper();
        cafm.lv.applyIndices(e);

        if (w.length && !w.data('listView')) {
            
            w.data('listView', lv);

            // set list info label widths
            w.find('.list-info').setLabelWidths({
                labelSelector: '.info-label'
            });

            // show / hide detail sections if this feature is enabled
            if (o.EnableShowHideDetail && !isMobile) {

                if (w.data('detailOn')) {

                    w.find('.list-detail').show();
                }
                else {

                    w.find('.list-detail').hide();
                }
            }
            else if(isMobile){
                                
                cafm.lv.setupMobileList(o, lv);
            }
        }
        else if (w.length) {

            if (w.data('detailOn')) {

                w.find('.cDetail').show();
            }
        }

        cafm.lv.displayItems({
            listView: lv,
            items: $('.cLvIt', lv),
            selectedItems: w.getSelectedItemUids()
        });

        var total = e.sender.dataSource ? e.sender.dataSource.total() : 0;

        if(!isMobile && total > 0){

            $('.cLvSortWrap,.cToggleDetail', w).show();
        }

        if (o.PageSize > 0) {
            if (total > 1) {
                cafm.util.modifyPager(w, e.sender.dataSource, o);
            }
            else {
                $('.k-pager-wrap', w).hide();
            }
        }

        var editBtn = $('.cTb [data-key="Edit"]', w);

        if (editBtn.length) {

            var editHandler = function (e) {

                var ed = $(e.currentTarget).hasClass('cLvIt') ? $(e.currentTarget) : $(e.currentTarget).closest('.cLvIt');
                editBtn.data('editTarget', ed);
                editBtn.click();
            };

            if (!isTouch) {

                lv.off('dblclick.lv').on('dblclick.lv', '.cLvIt', editHandler);
            }
            else {

                $('.cLvIt .contextTitle', lv).click(editHandler).addClass('cLink');
            }

        }

        if (o.OnDataBound) {

            cafm.handlers.exe(o.OnDataBound, e);
        }
    },
    setupListHeader: function (wrapper, listView, options) {

        if (!isMobile && !wrapper.data('header')) {
            var h = $('.cLvHead', wrapper);
            if (h.length) {
                wrapper.data('header', h);

                var tb = $('.cTb', h);
                if (tb.length)
                    tb.setupToolbar({ container: wrapper });

                var detTogg = $('.cToggleDetail', h);
                if (detTogg.length) {
                    detTogg.click(cafm.lv.onToggleDetail);
                }

                var s = options.Sorting;
                if (s) {
                    if (s.Options) {
                        var sd = $('.cLvSort', h).kendoDropDownList({
                            dataTextField: 'Name',
                            dataValueField: 'Field',
                            dataSource: s.Options,
                            change: cafm.lv.sort
                        });
                        wrapper.data('sortDropdown', sd);
                        var sdd = $('.cLvSortDir', h).kendoDropDownList({
                            change: cafm.lv.sort
                        });
                        wrapper.data('sortDirDropdown', sdd);
                    }
                    var d = s.Default;
                    if (d) {
                        sd.data('kendoDropDownList').value(d.Field);
                        sdd.data('kendoDropDownList').value(cafm.ds.toSortDirString(d.Direction));
                    }
                }
            }
        }
    },
    showNoItems: function (w, o) {
        /// <summary>Show no items handler for list view</summary>
        /// <param name="w" type="JQuery">The list view wrapper element</param>
        /// <param name="o" type="String">The list view options</param>
        var noItemsTxt = o.NoItemsMessage ? o.NoItemsMessage : cafm.res.str.TextNoItems;
        cafm.lv.showMessageInMsgPanel(w, noItemsTxt);
    },
    showSelectFiltersFirstMessage(w) {
        /// <summary>Shows message asking User to select filter first</summary>
        /// <param name="o" type="Object">The grid options</param>        
        cafm.lv.showMessageInMsgPanel(w, cafm.res.str.TextSelectFiltersToPerformSearch);
    },
    showMessageInMsgPanel(w,m) {
        /// <summary>Shows empty grid message and hides the empty grid</summary>
        /// <param name="w" type="Object">The list wrapper element</param>        
        /// <param name="t" type="Object">The message type</param>        
        /// <param name="m" type="Object">The message</param>      
        if (!isMobile) $('.cLvSortWrap,.cToggleDetail', w).hide();
        var target = $('.listview-noitems', w);
        
        if (!target.length) {
            target = $('<span />', {
                'class': 'listview-noitems',
            });
        }
        target.text(m);
        var lv = $('.k-listview', w);
        if (lv.length) {
            target.insertBefore(lv);
            lv.hide();
            target.show();
        } else {
            w.append(target);
        }
    },
    displayItems: function (o, i) {
        /// <summary>Shows/animates the list view items - recursive method starts from 0 ends at the number of items to show on the list view page</summary>
        /// <param name="items" type="Object">The list view items</param>
        /// <param name="i" type="Integer">The current item index</param>
        
        o.listView.fadeIn();
    },
    sort: function (e) {
        /// <summary>Handler for changing the list view sorting</summary>
        /// <param name="e" type="Object">The sorting dropdown event</param>

        var w = e.sender.element.getLvWrapper();
        var f = w.data('sortDropdown').val();
        var d = w.data('sortDirDropdown').val();
        cafm.lv.sortList(w, f, d);
    },
    sortList: function (w, f, d) {
        /// <summary>Sorts a list view</summary>
        /// <param name="w" type="Object">The list wrapper element</param>
        /// <param name="f" type="JQuery">The field name to sort by</param>
        /// <param name="d" type="String">The sort direction</param>

        w.getLv().dataSource.sort({ field: f, dir: d });
    },
    applyIndices: function (e) {
        /// <summary>Applies data-index and data-alt attributes to the list items</summary>
        /// <param name="e" type="Object">The list view data bound event</param>

        $('> li', e.sender.element).each(function (i, item) {
            $(item).attr('data-index', i);
            $(item).attr('data-alt', i % 2 == 1);
        });
    },
    onToggleDetail: function (e) {
        /// <summary>Handler for toggling list detail</summary>
        /// <param name="e" type="Object">The button click event</param>

        var s = $(e.target);
        cafm.lv.toggleDetail(s);
    },
    toggleDetail: function (s) {
        /// <summary>Handler for toggling list detail</summary>
        /// <param name="s" type="Object">The source element</param>

        var w = s.getLvWrapper();

        if (w.length) {

            w.find('.cDetail').toggle();
        }

        s.toggleClass('on');
        w.data('detailOn', s.hasClass('on'));
    },
    render: function (o) {
        /// <summary>Renders the list view element</summary>
        /// <param name="o" type="Object">List view options</param>

        // get wrapper and list elements
        var wrapper = $('#{0}'.format(o.ClientId)),
            lvEl = $('.cLv', wrapper),
            criteria = o.Criteria;

        // call pre build control if there is one
        if (o.OnPreBuildControl) {

            cafm.util.callFunction(o.OnPreBuildControl, o, lvEl);
        }

        // is this list in a lookup?
        var isLookupList = wrapper.closest('.lookupGrid').length > 0;

        // is this list inside an action form on the main form panel
        var isMainActionForm = wrapper.parents('.actionForm').parents('#mainForm');

        // apply criteria to the list control
        if (criteria) {

            lvEl.setCriteria(criteria);
        }
        else {

            criteria = lvEl.getCriteria();
        }

        // create the search datasource
        var ds = cafm.ds.createSearchDataSource({
            element: lvEl,
            control: function () { return lvEl.getLv(); },
            options: o,
            criteria: criteria,
            dataSourceChanged: cafm.lv.dataSourceChanged
        });

        var selectableValid = o.Selectable != cafm.enums.Selectable.Disabled && ($('.cTb button', wrapper).length || isLookupList || isMainActionForm);

        // implement custom selection behaviour for touch devices
        if (isTouch && selectableValid) {

            if (o.Selectable == cafm.enums.Selectable.Multiple || (cafm.browsers.isEdgeMobile() && o.Selectable == cafm.enums.Selectable.Single)) {

                o.Selectable = cafm.enums.Selectable.Disabled;

                lvEl.touchTap('.cLvIt', function (e) {
                    
                    var item = $(e.currentTarget);  

                    if (cafm.enablingPermissibleFeatures || !lvEl.hasClass('touch-selectable') || $(e.target).is('.asset-item-menu-btn,.asset-item-icon,.asset-item-text,.asset-actioned,.asset-failed')) {
                        return;
                    }
                    
                    var listView = item.getLv();
                    listView.toggleItem(item);
                    listView.trigger('change');

                    if (o.OnSelectionChanged) {

                        cafm.handlers.exe(o.OnSelectionChanged, {
                            sender: listView
                        });
                    }
                });

                lvEl.addClass('touch-selectable');
            }
        }

        var selectable = selectableValid && o.Selectable != cafm.enums.Selectable.Disabled ? cafm.enums.getEnumKey(cafm.enums.Selectable, o.Selectable).toLowerCase() : false;

        var lvOpts = {
            dataSource: ds,
            template: kendo.template($('#{0}'.format(o.ItemClientTemplateId)).html()),
            selectable: selectable,
            //pageable: pageable,
            navigatable: o.EnableKeyboardNavigation,
            autoBind: o.AutoBind,
            dataBound: function (e) {

                lvEl.setDataSource(ds);
                cafm.lv.setup(o, e);
                
                if (o.OnItemLinkClick) {

                    var onLinkClick = cafm.util.getReference(o.OnItemLinkClick);
                    
                    if (isFunc(onLinkClick)) {

                        e.sender.element.listItemLinkClick(onLinkClick);
                    }
                }

                if (lvEl.data('initialising')) {

                    lvEl.removeData('initialising');
                }
                
                $('[data-onclick]', lvEl).setupEvents();
            }
        };

        lvEl.data('initialising', true);

        if (!o.AutoBind) {

            cafm.lv.setup(o, { sender: { element: lvEl, dataSource: ds } });
            lvEl.setDataSource(ds);
            if (o.ShouldAutoSearchEvalFunction) {
                let autoSearch = cafm.util.callFunction(o.ShouldAutoSearchEvalFunction);
                if (!autoSearch) {
                    cafm.lv.showSelectFiltersFirstMessage(wrapper);
                } else {
                    o.AutoBind = true;
                    lvOpts.autoBind = true;
                }
            }
        }
        if (selectable) {

            lvOpts.change = function (e) {

                if (cafm.enablingPermissibleFeatures) {

                    e.sender.element.find('.cLvIt.k-state-selected').removeClass('k-state-selected');
                    return;
                }

                cafm.lv.selectionChanged(e, o.Selectable);

                if (o.OnSelectionChanged) {

                    cafm.handlers.exe(o.OnSelectionChanged, e);
                }
            }
        }

        wrapper.clearSelectedItemUids();
        ds.listView = lvEl.kendoListView(lvOpts).data('kendoListView');
        cafm.lv.setupListHeader(wrapper, ds.listView, o);

        if (o.PageSize > 0) {
            
            if (o.ItemName && o.CollectionName) {

                o.PagerMessage = cafm.res.str.TemplatePagerMessage + ' ' + o.CollectionName;
                o.PagerSinglePageMessage = '{0} ' + o.CollectionName;
                o.PagerSingleMessage = '{0} ' + o.ItemName;
            }
            else {

                o.PagerMessage = cafm.res.str.TemplatePagerMessage + ' ' + cafm.res.str.LabelItems.toLocaleLowerCase();
                o.PagerSinglePageMessage = '{0} ' + cafm.res.str.LabelItems.toLocaleLowerCase();
                o.PagerSingleMessage = '{0} ' + cafm.res.str.LabelItem.toLocaleLowerCase();
            }

            var pager = $('#{0} .cLvPager'.format(o.ClientId)).kendoPager({
                dataSource: ds,
                messages: {
                    display: o.PagerMessage
                }
            });

            if (o.DataSourceUrl) pager.hide();
            else if (o.AutoBind) {
                cafm.util.modifyPager(wrapper, ds, o);
            }
        }
    },
    dataSourceChanged: function (e) {

        if (e.sender.listView) {
            var lve = $(e.sender.listView.element);
            // only fire datasource changed when we're not already going off to the server
            if (!lve.data('initialising') && !lve.data('requestActive')) {
                var onDataSourceChanged = lve.data('dataSourceChanged');
                if (isFunc(onDataSourceChanged)) {
                    onDataSourceChanged(e);
                }
            }
        }
    },
    selectionChanged: function (e, selectable) {
        /// <summary>Core CAFM handler for list view selection events</summary>
        /// <param name="e" type="Object">The list view change event argument</param>
        /// <param name="selectable" type="String">The selectable mode being either multiple, or single</param>

        var lvWrap = e.sender.element.getLvWrapper();
        var selected = lvWrap.getSelectedItemUids();

        if (!selected || selectable == cafm.enums.Selectable.Single) {

            selected = [];
        }
        $.each(e.sender.items(), function (i, item) {

            var item = $(item);
            var uid = item.data('uid');
            var ind = cafm.util.indexOf(selected, function (sid) {
                return sid == uid;
            });
            if (item.hasClass('k-state-selected')) {
                if (ind == -1) {
                    selected.push(uid);
                }
            }
            else if (ind > -1) {
                selected.splice(ind, 1);
            }
        });
        lvWrap.setSelectedItemUids(selected);
    },
    setupMobileList: function(o, lv){
        /// <summary>Sets up the mobile list with applicable sorting, filter etc</summary>
        /// <param name="o" type="Object">The list view options</param>
        /// <param name="lv" type="Object">The list view options</param>

        if (o.EnableShowHideDetail)
        {
            var w = lv.getLvWrapper();
            w.data('detailOn', true).find('.cDetail').show();
        }

        // if showing the footer then setup the buttons
        if (o.ShowMobileListFooter) {
            
            var h = $('#header-container');

            // setup sorting options list
            if (o.MobileSorting) {

                var l = $('#' + o.MobileSorting.ClientId);
                l.setupBasicList();

                $('.mobileListSortingBtn', h).click(function () {

                    l.parent().toggle();
                    cafm.filters.hidePanel();
                    $('#mobileMenu').hide();
                });

                $('.mobileListRefreshBtn', h).click(function () {

                    lv.refreshListDS({ resetPage: true });
                });                
            }

            if (o.ShowCreateNewButtonOnHeader && o.CreateButtonHandler) {
                $('.mobileListCreateNewBtn', h).click(function () {
                    cafm.util.callFunction(o.CreateButtonHandler);
                });                
            }

            var crit = lv.getCriteria();

            if (crit && cafm.util.hasItem(crit.SortOptions)) {

                var so = crit.SortOptions[0];
                var li = l.find('[data-value="{0}"]'.format(so.Field));
                li.attr('data-dir', cafm.ds.toSortDirString(so.Direction));
            }

            // apply default sort style to item            
            else if (o.Sorting && o.Sorting.Default) {

                var dso = o.Sorting.Default;
                var li = l.find('[data-value="{0}"]'.format(dso.Field));
                li.attr('data-dir', cafm.ds.toSortDirString(dso.Direction));
            }

            if (o.IntegrateWithSearchFilters) {

                $('.mobileListFilteringBtn', h).click(function () {

                    cafm.filters.showPanel();

                    if (o.MobileSorting) {

                        $('#' + o.MobileSorting.ClientId).parent().hide();
                    }
                    $('#mobileMenu').hide();
                });
            }
        }
    },
    onMobileSortItemPressed: function (e) {
        /// <summary>Handler for mobile list view sorting</summary>
        /// <param name="e" type="Object">DOM event object</param>
        
        var item = $(e.currentTarget);

        var w = item.getLvWrapper();
        var f = item.data('value');
        var d = item.attr('data-dir');

        if (isUndefined(d) || d === 'desc') {
            d = 'asc';
        }
        else {
            d = 'desc';
        }

        item.parent().find('li').removeAttr('data-dir');
        item.attr('data-dir', d);

        var lv = w.getLv();
        var lvEl = lv.element;
        var serverSort=false;
        //Check if this is main List then set criteria
        var crit = lvEl.getCriteria();
        if (crit) {
            serverSort = true;
            crit.HasChanged = true;
            var so = crit.SortOptions ? crit.SortOptions[0] : null;
            if (isNullOrUndefined(so)) {
                so = {};
                crit.SortOptions = [so];
            }

            so.Field = f;
            so.Direction = d === 'asc' ? cafm.enums.ListSortDirection.Ascending : cafm.enums.ListSortDirection.Descending;
            lvEl.setCriteria(crit);
        }

        var ds = lv.dataSource;

        if (lvEl.data('offlineWidget') || serverSort===false) {
            ds.options.serverSorting = false;
            ds.sort({ field: f, dir: d });
        }
        else {

            ds.read();
        }
        return false;
    }
}